import { Component, Input, NgModule, NO_ERRORS_SCHEMA, AfterViewInit, Output, EventEmitter, ViewChild, ChangeDetectorRef, Inject, ChangeDetectionStrategy, OnDestroy, ViewEncapsulation, forwardRef } from '@angular/core';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldAppearance, MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from "@angular/material/input";
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';

import moment from 'moment/moment';
import { defaultFormat as _rollupMoment } from 'moment';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { DatepickerHeaderComponent, DatepickerHeaderModule } from './DatepickerHeader.component';
import { CalendarService } from './services/calendar.service';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Constants } from "@dealpos-npm/ng-dealpos-library/constants";
declare var bootstrap: any;
// const moment = _rollupMoment || moment;

export const MY_FORMATS = {
    parse: {
        dateInput: 'DD MMM YYYY',
    },
    display: {
        dateInput: 'DD MMM YYYY',
        monthYearLabel: 'MMM YYYY',
        dateA11yLabel: 'LL',
        monthYearA11yLabel: 'MMMM YYYY',
    },
};

@Component({
    selector: 'datepicker',
    templateUrl: './datepicker.component.html',
    styleUrls: ['./datepicker.component.scss'],
    providers: [
        { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
        { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => DatepickerComponent),
            multi: true,
        }
    ],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class DatepickerComponent implements OnDestroy, ControlValueAccessor {
    /**
     * custom ui for header to adding new functionality ex: today, Clear
     */
    public headerComponent = DatepickerHeaderComponent;
    @Input() data_cy: string; // for e2e testing purposes
    @Input() placeholder: string;
    @Input() displayToggle: boolean;
    @Input() appearance: MatFormFieldAppearance = 'outline';
    @Input() width: string;
    @Input() isFloatingLabel: boolean = true;
    @Input() date: any;
    @Input() disabled = false;
    @Input() readOnly = false;
    @Input() minDateValidation = null;
    @Input() maxDateValidation = null;
    @Input() set hideClearBtn(val: any) {
        this.calendarService
            .setHeaderConfig({ hideBtnClear: val, hideBtnToday: this.calendarService.calendarConfig.hideBtnToday });
    };

    @Output() dateChange: EventEmitter<Date | null> = new EventEmitter<Date | null>();

    minDate = Constants.MinDate;

    /**
     * We lie to the compiler, the correct parameter value is moment.Moment
     * @param newDate 
     */
    public change(momentValue: moment.Moment): void {
        let date: Date | null = null;
        if (momentValue) {
            date = momentValue.toDate();
            // set time to 00:00:00
            date.setHours(0, 0, 0, 0);
        }
        this.dateChange.emit(date);
        this.onChange(date);
    }

    constructor(
        private calendarService: CalendarService,
    ) {
        this.displayToggle = true;
    }

    onOpenDatepicker() {
        const dropdownElement = document.getElementById("dropdown-filter");
        if (dropdownElement) {
            var myDropdown = new bootstrap.Dropdown(dropdownElement);
            if (myDropdown) {
                myDropdown._config.autoClose = 'inside'
            }
        }
    }

    onCloseDatepicker() {
        const dropdownElement = document.getElementById("dropdown-filter");
        if (dropdownElement) {
            var myDropdown = new bootstrap.Dropdown(dropdownElement);
            if (myDropdown) {
                myDropdown._config.autoClose = 'outside'
            }
        }
    }

    ngOnDestroy(): void {
        this.calendarService.setHeaderConfig({ hideBtnClear: false, hideBtnToday: false })
    }

    writeValue(val: any): void {
        if (val) {
            this.date = val;
        }
    }

    onChange: Function = (_: any) => { };
    registerOnChange(fn: any): void {
        this.onChange = fn;
    }
    registerOnTouched(fn: any): void {
    }

    setDisabledState?(isDisabled: boolean): void {
        this.disabled = isDisabled;
    }
}
@NgModule({
    imports: [
        CommonModule,
        MatButtonModule,
        MatNativeDateModule,
        MatDatepickerModule,
        MatFormFieldModule,
        MatInputModule,
        DatepickerHeaderModule
    ],
    providers: [
        MatDatepickerModule
    ],
    declarations: [DatepickerComponent],
    exports: [DatepickerComponent],
    schemas: [NO_ERRORS_SCHEMA],
})
export class DatepickerModule { }